import products from './SrManagementTeamData';
import { Col } from 'react-bootstrap';
export default function Products() {
   const handleBookMeeting = (url) => {
    if (window.Calendly) {
      Calendly.initPopupWidget({ url });
    } else {
      console.warn("Calendly script not loaded");
    }
  };
  
 // console.log(products); // Log the products data to ensure it's correct
  const productsList = products.map((product, index) => (
    <Col xs={12} md={2} key={product.id || index}> {/* Use product.id or index */}
      <div className="wpr-member-media">
        <img src={product.img} alt={product.Mname} className="img-fluid" />
      </div>
      <div className="wpr-member-content">
        <h3 className="wpr-member-name">{product.Mname}</h3>
        <div className="wpr-member-job">{product.designation}</div>
         {/* Show Calendly link only if available */}
            {product.calendly && (
              <button
                onClick={() => handleBookMeeting(product.calendly)}
                className="btn btn-connect mt-2"
              >
                Schedule time with me
              </button>
            )}
            <div className="wpr-member-divider"></div>
      </div>
    </Col>
  ));

  return <>{productsList}</>; // Return the list of items
}
